export function redirectTo(link, evt) {
  if (evt.key && evt.key !== 'Enter') {
    return
  }

  window.location.href = link

  return true
}
